import Exercise from '@/api/exercise';
import { createConversationContent } from './mass-import/conversation-content';
import { cleanupExerciseContent, createExercise } from './mass-import/exercise';
import { createListeningContent } from './mass-import/listening-content';
import { createSpeakingContent } from './mass-import/speaking-content';
import { safeLock } from './common/util';

export async function importExercise(data: { [key: string]: string }) {
  const exercise = await createExercise(data);
  return exercise;
}

export async function importExerciseContent(
  exercise: Exercise,
  data: { [key: string]: string }
) {
  await safeLock(Exercise.SLUG, exercise.id, async () => {
    await cleanupExerciseContent(exercise);
    await createConversationContent(data, exercise);
    await createSpeakingContent(data, exercise);
    await createListeningContent(data, exercise);
    return 0;
  });

  return exercise.id;
}
